import { Grid, TextField, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React from "react";
import { LocalOfferOutlined, Restore as RestoreIcon } from "@mui/icons-material";
import { map } from "lodash/fp";
import { UsersFiltersType } from ".";
import { useQuery } from "@apollo/client/react";
import FilterAutocomplete from "@/components/FilterAutocomplete";
import { CompanyTag, GetCompanyTagsDocument } from "@/graphql/generated/graphql";

interface UsersFiltersProps {
  filters: UsersFiltersType;
  onChange: <K extends keyof UsersFiltersType>(key: K, value: UsersFiltersType[K]) => void;
  onReset: () => void;
  disableReset: boolean;
}

const mapTags = map((item: Pick<CompanyTag, "id" | "title">) => ({ id: item.id, title: item.title }));

const UsersFilters: React.FC<UsersFiltersProps> = ({
  filters,
  onChange,
  onReset,
  disableReset,
}) => {
  const { data } = useQuery(GetCompanyTagsDocument);

  return (
    <Grid container size={12} alignItems="center" flexWrap="nowrap" sx={{ my: 1 }}>
      <TextField
        id="users-search"
        size="small"
        placeholder="Type to search by first name, last name or email..."
        fullWidth
        value={filters.search}
        onChange={(e) => onChange("search", e.target.value)}
        label={
          <Grid container alignItems="center">
            <SearchIcon fontSize="small" /> &nbsp; Search
          </Grid>
        }
        sx={{ mr: 1 }}
      />
      <FilterAutocomplete
        id="tag-ids"
        fullWidth
        multiple
        autoHighlight
        disableClearable
        getOptionLabel={(option) => option.title}
        options={mapTags(data?.getCompanyTags)}
        value={filters.tags ?? []}
        onChange={(_, tags) => onChange("tags", tags)}
        isOptionEqualToValue={(option, value) => {
          return option.id === value.id
        }}
        textFieldLabel={
          <Grid container alignItems="center">
            <LocalOfferOutlined fontSize="small" /> &nbsp; Tags
          </Grid>
        }
        sx={{ mr: 1 }}
      />
      <Button
        size="small"
        variant="outlined"
        onClick={onReset}
        startIcon={<RestoreIcon />}
        disabled={disableReset}
        sx={{ px: 10 }}
      >
        Reset
      </Button>
    </Grid >
  )
}

export default UsersFilters;
